module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"132\" height=\"132\" viewBox=\"0 0 132 132\">\n    <g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(2 2)\">\n        <circle cx=\"64\" cy=\"64\" r=\"64\" stroke=\"#FFC212\" stroke-width=\"4\"/>\n        <path fill=\"#FFC212\"  stroke=\"#fff\" d=\"M92.502 49.663L58.665 83.5 38.701 63.535l4.46-4.46 15.504 15.503 29.376-29.376 4.46 4.461z\"/>\n    </g>\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./src/common/components/icons/complete.icon.html
// module id = 1046
// module chunks = 0